import { useEffect, useState, useContext, useLayoutEffect } from 'react';
import { MapContainer, TileLayer, useMap, Marker, Popup, useMapEvents } from 'react-leaflet';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationPin } from '@fortawesome/free-solid-svg-icons';
import { renderToString } from 'react-dom/server';
import API from "../../lib/devApi";

import L from 'leaflet';
import { GestureHandling } from "leaflet-gesture-handling";

import './providerMap.css';

import 'leaflet/dist/leaflet.css';
import "leaflet-gesture-handling/dist/leaflet-gesture-handling.css";
import marker from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';
import { useBreakpoints, useIsMobile } from '../hooks';
import { DevContext } from '../context';
import { LeafletFnWrapper, ProviderDto } from '../../models';

const defaultIcon = L.icon({
    iconUrl: marker,
    shadowUrl: markerShadow
});

const customIcon = <FontAwesomeIcon icon={faLocationPin} fontSize={36} />
const customIcon2 = <FontAwesomeIcon icon={faLocationPin} fontSize={52} />
const selectedIcon = <FontAwesomeIcon icon={faLocationPin} style={{color: "gray !important"}} fontSize={36} />

const divIcon = L.divIcon({
    html: renderToString(customIcon),
    iconSize: [30, 42],
    iconAnchor: [15, 42],
    className: "icon-bg"
})

const divIconLg = L.divIcon({
    html: renderToString(customIcon2),
    iconSize: [30, 42],
    iconAnchor: [15, 42],
    className: "icon-bg"
})

const divSelectedIcon = L.divIcon({
    html: renderToString(selectedIcon),
    iconSize: [30, 42],
    iconAnchor: [15, 42],
    className: "icon-bg"
})

L.Marker.prototype.options.icon = defaultIcon;
L.Map.addInitHook("addHandler", "gestureHandling", GestureHandling);

export default function ProviderMap(props: any) {

    const isMobile = useIsMobile();
    const breakpoint = useBreakpoints();

    let defaultWidth = 0;
    switch(breakpoint) {
        case "xs":
        case "sm":
        case "md":
            defaultWidth = window.innerWidth;
            break;
        case "lg":
        case "xl":
        case "xxl":
            // defaultWidth = Math.floor(window.innerWidth/2);
            defaultWidth = Math.floor(window.innerWidth - 630);
            break;
    }

    const [mapWidth, setMapWidth ] = useState(defaultWidth);


    useEffect(() => {
        if(!window.onorientationchange) {
            window.onorientationchange = () => {
                setMapWidth(window.innerWidth);
            };
        }
    }, []);

    const renderZoom = () => {
        switch(breakpoint) {
            case "xs":
            case "sm":
                return 8;
            case "md":
            case "lg":
            case "xl":
            case "xxl":
                return 9;
        }
    }

    const Map = (props: any) => {
        const { mapContext, setMapContext, providers, setShowLoading, setProviderAuxiliaryData, setSelectedProvider, selectedProvider } = useContext(DevContext);

        useEffect(() => {
            if(providers) {
                providers.items.forEach((provider: ProviderDto) => {
                    if(mapContext && mapContext.current) {
                        const marker = L.marker([provider.latitude, provider.longitude], {
                            title: provider.name,
                            icon: divIcon
                        });

                        marker.bindTooltip(provider.name);
                        
                        marker.on('click', async (e) => {
                            // if(highlightedMarker) {
                            //     console.log(highlightedMarker);
                            //     if(mapContext && mapContext.current) {
                            //         highlightedMarker.setIcon(divIcon);
                            //         highlightedMarker.addTo(mapContext.current);
                            //     }
                            // }
                            // console.log(e);
                            // marker.setIcon(divSelectedIcon);
                            // setHighlightedMarker(e.target);  

                            marker.openTooltip();

                            if(mapContext && mapContext.current) {
                                // Change the other markers to gray and selected marker to green.
                                // let currentMarker;
                                // mapContext.current.eachLayer((layer) => {
                                //     currentMarker = layer as L.Marker;
                                //     if(currentMarker.setIcon) {
                                //         if(provider.name == currentMarker.options.title) {
                                //             currentMarker.setIcon(divIcon);
                                //         }
                                //         else {
                                //             currentMarker.setIcon(divSelectedIcon);
                                //         }
                                //     }
                                // });
                    
                                // mapContext.current.panTo([provider.latitude, provider.longitude])

                                // Get selected provider auxiliary data
                                try {
                                    setShowLoading(true);
                                    const result = await API.GetProviderAuxiliaryData(provider.providerId);
                                    setProviderAuxiliaryData(result);
                                    setSelectedProvider(provider);
                                } catch (error) {
                                    
                                }
                                finally {
                                    setShowLoading(false);
                                }
                            }

                        });
                        
                        // marker.addTo(mapContext.current);
                        marker.addTo(mapContext.current);
                        // console.log("Layers", mapContext.current)
                    }
                });
            }
        }, [providers]);

        useEffect(() => {

            if(mapContext && mapContext.current && selectedProvider) {
                // Change the other markers to gray and selected marker to green.
                let currentMarker;
                mapContext.current.eachLayer((layer) => {
                    currentMarker = layer as L.Marker;
                    if(currentMarker.setIcon) {
                        if(selectedProvider.name == currentMarker.options.title) {
                            currentMarker.setIcon(divIconLg);
                        }
                        else {
                            currentMarker.setIcon(divSelectedIcon);
                        }
                    }
                });
    
                mapContext.current.panTo([selectedProvider.latitude, selectedProvider.longitude])
    
            }

        }, [selectedProvider])

        // useEffect(() => {
        //     if(mapContext && mapContext.current) {
        //         mapContext.current.eachLayer((layer) => {
        //             console.log(layer);
        //         })
        //     }
        // }, [mapContext]);

        // const map = useMapEvents({
        //     loading: () => {
        //         map.locate({setView: true, maxZoom: 16});
        //     }
        // })
        // const map = useMapEvents({
        //     click: () => {
        //         map.locate({setView: true, maxZoom: 16})
        //     },
        //     locationfound: (location) => {
        //         console.log('location found:', location)
        //     },
        // })

        const map: any = useMap();
        if(isMobile)
            map.gestureHandling.enable();
        else
            map.gestureHandling.disable();
        // const mapOptions: any = {
        //     gestureHandling: true
        // };
        // const map = L.map("map", mapOptions);

        // map.fitWorld();
        // map.locate({setView: true, maxZoom: 16});
        // map.setCenter([18.2208, -66.5901]);
        // map.panTo([18.2208, -66.5901]);
        //[17.777, -66.0366]
        // map.invalidateSize();
        // map.panTo([18.2208, -66.5901]);
        
        // map.setView([18.2208, -66.5901], 9);
        
        // map.panTo([18.2208, -66.5901]);
        // map.setMaxBounds(map.getBounds());
        // map.flyTo([18.2208, -66.5901]);
        // map.invalidateSize(true);
        // if(mapContext && mapContext.current)
        //     mapContext.current = map;
        setMapContext(map);

        // setPanTo((lat: number, long: number) => {
        //     map.panTo([lat, long]);
        // });

        // setTimeout(() => {
        //     map.panTo([18.2208, -66.5901])
        // }, 5000)

        // props.mapRef.current = map;

        return null;
    }

    return (
        // renderZoom()
        // maxZoom={19}
        // center={[18.2208, -66.5901]}
        <MapContainer style={{height: "100%", width: mapWidth}} center={[18.2208, -66.5901]} zoom={renderZoom()} scrollWheelZoom={false} >
            <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <Map />
        </MapContainer>
    );
}